import { render, staticRenderFns } from "./PageHeaderWithButton.vue?vue&type=template&id=85dddf4a&scoped=true"
import script from "./PageHeaderWithButton.vue?vue&type=script&lang=js"
export * from "./PageHeaderWithButton.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderWithButton.vue?vue&type=style&index=0&id=85dddf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dddf4a",
  null
  
)

export default component.exports